export default __webpack_public_path__ + "static/media/image-slider-1.2f2609e2.png";